import { useTranslation } from "react-i18next";
import "./ReusableDocuments.css";
import { Button } from "@shopify/polaris";
import InspectionElement from "../types/InspectionElement";
import ReusableElementCard from "../components/ArtifactElementCard/ReusableElementCard";
import { useEffect, useState } from "react";
import { ReuseSubmitDialog } from "../components/ReuseSubmitDialog/ReuseSubmitDialog";
import {useDispatch, useSelector} from "react-redux";
import { updateInspectionReportReuse, updateInspectionReuseStatus } from "../store/actions/Inspections";
import { DocumentReuseStatus } from "../types/Inspection";

type ReusableDocumentsProps = {
    inspectionId: string;
    inspectionElements: InspectionElement[];
}

export const ReusableDocuments = ({
    inspectionId,
    inspectionElements
}: ReusableDocumentsProps) => {
    const { t } = useTranslation("common");
    const [submitDialogActive, setSubmitDialogActive] = useState<boolean>(false);
    const [reusableElements, setReusableElements] = useState<InspectionElement[]>([]);
    const activeInspection = useSelector(
        (state: any) => state.portal.activeInspection
    );
    const dispatch = useDispatch();

    useEffect(() => {
        setReusableElements(
            inspectionElements
                .filter((element) => element.ReUseDocuments && element.Documents.length > 0)
                .map((element: InspectionElement) => Object.assign({}, element, {ValidForReuse: true}))
        );

    }, [inspectionElements]);

    const handleSkipReuse = () => {
        dispatch(
            updateInspectionReuseStatus(inspectionId, DocumentReuseStatus.NOT_RE_USE, reusableElements,activeInspection));
    }

    const closeSubmitDialog = () => {
        setSubmitDialogActive(false);
    }

    const handleSubmit = () => {
        setSubmitDialogActive(true);
    }

    const submitElementsForReuse = () => {
        dispatch(updateInspectionReportReuse(inspectionId, reusableElements, activeInspection));
    }

    const handleReuseClick = (element: InspectionElement) => {
        const elementToUpdate = reusableElements.find((el) => el.Id === element.Id);
        if (elementToUpdate) {
            elementToUpdate.ValidForReuse = !elementToUpdate.ValidForReuse;
        }

        const newReuseableElements = reusableElements.map((el) => {
            if (el.Id === element.Id) {
                return element;
            }
            return el;
        });

        setReusableElements(newReuseableElements);
    }

    const getElementCards = () => {
        return reusableElements.map((element) => {
            return (
                <ReusableElementCard key={element.Id} inspectionElement={element} updateValidReuseDocuments={handleReuseClick} />
            )
        });
    }

    const calculateValidDocumentCount = () => {
        let count = 0;
        reusableElements.filter(e => e.ValidForReuse).forEach((element) => {
            count += element.Documents.length;
        });

        return count;
    }

    return (
        <div id="reusable-documents-page-container" className="reusable-documents-page-container">
            <ReuseSubmitDialog 
                active={submitDialogActive} 
                submitDocuments={submitElementsForReuse}
                closeModal={closeSubmitDialog} 
                documentCountFunction={calculateValidDocumentCount} />
            <div className="reusable-documents-page-header">
                <div>{t("reuseDocuments.pageTitle")}</div>
                <div className="reusable-documents-page-header-buttons">
                    <Button submit size="large" onClick={handleSkipReuse}>{t("reuseDocuments.skip")}</Button>
                    <Button primary
                            size="large"
                            onClick={handleSubmit}>
                        {t("reuseDocuments.submit")}
                    </Button>
                </div>
            </div>
            <div className="reuse-documents-description">{t("reuseDocuments.description")}</div>
            <div className="reusable-documents-list">
                {getElementCards()}
            </div>
        </div>
    )
}